import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70333bdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "friendsSidebar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Friends", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Inbox", -1))
const _hoisted_5 = { class: "listOfPeople" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "monogram" }
const _hoisted_8 = { class: "manageFriendRequestButtons" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Outbox", -1))
const _hoisted_12 = { class: "listOfPeople" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "monogram" }
const _hoisted_15 = { class: "manageFriendRequestButtons" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Your Friends", -1))
const _hoisted_18 = { class: "currentFriends listOfPeople" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "monogram" }

import store from "@/store";
import axios from "axios";
import { ComputedRef, computed, ref } from "vue";
import AddIcon from "@/components/Icons/AddIcon.vue";
import CheckmarkIcon from "@/components/Icons/CheckmarkIcon.vue";
import CancelIcon from "@/components/Icons/CancelIcon.vue";

// Type declations
type Friendship = {
  friendship_id: string;
  user: {
    user_id: string;
    name: string;
    avatar?: string;
  };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'FriendsSidebar',
  emits: ["selected"],
  setup(__props, { emit: __emit }) {

// Imports
const emit = __emit;

// Refs/Props/Computed
const friends: ComputedRef<Record<string, Friendship[]>> = computed(
  () => store.state.friends
);
const selectedFromSidebar = ref("");

// FUNCTIONS

// Accept incoming friend request
async function acceptRequest(friendship: Friendship) {
  const friendship_id = friendship.friendship_id;
  try {
    await axios.patch("/friendships/pending", { friendship_id: friendship_id });

    store.dispatch("approveFriendship", friendship_id);

    selectedFromSidebar.value = friendship_id;

    emit("selected", friendship_id);
  } catch (err) {
    console.log(err);
  }
}
async function deleteRequest(friendship: Friendship) {
  const friendship_id = friendship.friendship_id;
  await sleep(500);

  try {
    await axios.delete("/friendships/delete", {
      data: { friendship_id: friendship_id },
    });

    store.dispatch("deleteFriendship", friendship_id);

    if (selectedFromSidebar.value == friendship_id) {
      selectedFromSidebar.value = "send";
    }
    // sending.value = false;
  } catch (err) {
    console.log(err);
    // sending.value = false;
  }
}

// Utils
async function sleep(milliseconds: number) {
  await new Promise((resolve) => {
    setTimeout(() => {
      resolve("done");
    }, milliseconds);
  });
}
function getMonogram(name: string) {
  return name.slice(0, 1).toUpperCase();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      ref: "sendFriendRequest",
      class: _normalizeClass([
        'sendFriendRequest',
        selectedFromSidebar.value == 'send' ? 'selectedFromSidebar' : '',
      ]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => {
        selectedFromSidebar.value = 'send';
        _ctx.$emit('selected', 'send');
      })
    }, [
      _createVNode(AddIcon),
      _createTextVNode("Add friend… ")
    ], 2),
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (!friends.value.incoming.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "You've Caught Up With Your Inbox!"))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friends.value.incoming, (friend) => {
        return (_openBlock(), _createElementBlock("button", {
          key: friend.friendship_id,
          tabindex: "-1"
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(getMonogram(friend.user.name)), 1),
          _createElementVNode("p", null, _toDisplayString(friend.user.name), 1),
          _createElementVNode("span", _hoisted_8, [
            _createElementVNode("button", {
              title: "Decline",
              onClick: ($event: any) => (deleteRequest(friend))
            }, [
              _createVNode(CancelIcon)
            ], 8, _hoisted_9),
            _createElementVNode("button", {
              title: "Accept",
              onClick: ($event: any) => (acceptRequest(friend))
            }, [
              _createVNode(CheckmarkIcon)
            ], 8, _hoisted_10)
          ])
        ]))
      }), 128))
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      (!friends.value.outgoing.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Your Outbox Is Empty!"))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friends.value.outgoing, (friend) => {
        return (_openBlock(), _createElementBlock("button", {
          key: friend.friendship_id,
          tabindex: "-1"
        }, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(getMonogram(friend.user.name)), 1),
          _createElementVNode("p", null, _toDisplayString(friend.user.name), 1),
          _createElementVNode("span", _hoisted_15, [
            _createElementVNode("button", {
              title: "Cancel",
              onClick: ($event: any) => (deleteRequest(friend))
            }, [
              _createVNode(CancelIcon)
            ], 8, _hoisted_16)
          ])
        ]))
      }), 128))
    ]),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      (!friends.value.current.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_19, "You're Not Friends With Anyone Yet!"))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friends.value.current, (friend) => {
        return (_openBlock(), _createElementBlock("button", {
          key: friend.friendship_id,
          onClick: ($event: any) => {
          selectedFromSidebar.value = friend.friendship_id;
          _ctx.$emit('selected', friend.friendship_id);
        },
          class: _normalizeClass(selectedFromSidebar.value == friend.friendship_id ? 'selectedFromSidebar' : '')
        }, [
          _createElementVNode("span", _hoisted_21, _toDisplayString(getMonogram(friend.user.name)), 1),
          _createElementVNode("p", null, _toDisplayString(friend.user.name), 1)
        ], 10, _hoisted_20))
      }), 128))
    ])
  ]))
}
}

})